
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollDetailsGrid extends Serenity.EntityGrid<PayrollDetailsRow, any> {
        protected getColumnsKey() { return 'HR.PayrollDetails'; }
        protected getDialogType() { return PayrollDetailsDialog; }
        protected getIdProperty() { return PayrollDetailsRow.idProperty; }
        protected getInsertPermission() { return PayrollDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return PayrollDetailsRow.localTextPrefix; }
        protected getService() { return PayrollDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}